import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCar, faTriangleExclamation, faCity } from "@fortawesome/free-solid-svg-icons";

const TrafficItem = ({ item }) => {
  const { title, description, roadType, roadName } = item;

  const safeRoadType = roadType ?? "";

  // Bestimme das passende Icon
  let icon;
  if (safeRoadType.includes("highway")) {
    icon = faCar;
  } else if (safeRoadType.includes("federal_road")) {
    icon = faCar;
  } else if (safeRoadType.includes("city_road")) {
    icon = faCity;
  } else {
    icon = faTriangleExclamation; // Standard-Icon setzen, falls keine Kategorie passt
  }

  return (
    <div className="trafficItem">
      <div className="trafficItemRoad">
        <FontAwesomeIcon icon={icon} size="2x" style={{ color: "#fffcfc" }} />
        <p className="roadNumber">{roadName && `${roadName}`}</p>
      </div>
      <div className="trafficItemContent">
        <h3>{title}</h3>
        <p>{description}</p>
      </div>
    </div>
  );
};

export default TrafficItem;
